import { Space, Typography, Col, Row, Spin } from 'antd'
import { Widget } from '../../components'
import W1 from "../../assets/widget_1.png"
import W2 from "../../assets/widget_2.png"
import W3 from "../../assets/widget_3.png"


const Widgets = ({ totalIncoming, totalUnprocessed, loading }) => {

    return (
        <div style={{ width: "100%" }}>

            <Row gutter={[18, 18]} >
                <Col md={8} xs={24} >
                    <Widget backgroundImage={W1} boxShadowColor="#5B94E8A3" >
                        <Col span={12} >
                            <Space direction='vertical'>
                                <Typography level={5} style={{ fontWeight: 400, fontSize: 18, color: "var(--color-white)", lineHeight: '22px' }}>Total Incoming</Typography>

                                <Typography level={4} style={{ fontWeight: 400, fontSize: 24, color: "var(--color-white)", lineHeight: '22px' }}>{loading ? 0 : totalIncoming}</Typography>

                            </Space>
                        </Col>
                    </Widget>
                </Col>
                <Col md={8} xs={24} >
                    <Widget backgroundImage={W2} boxShadowColor="#CA681AA3" >
                        <Col span={14} style={{ textAlign: "start" }}>
                            <Space direction='vertical'>
                                <Typography level={5} style={{ fontWeight: 400, fontSize: 18, color: "var(--color-white)", lineHeight: '22px' }}>Total Unprocessed</Typography>
                                <Typography level={4} style={{ fontWeight: 400, fontSize: 24, color: "var(--color-white)", lineHeight: '22px' }}>{loading ? 0 : totalUnprocessed}</Typography>
                            </Space>
                        </Col>

                    </Widget>
                </Col>
                <Col md={8} xs={24} >
                    <Widget backgroundImage={W3} boxShadowColor="#7C61F8A3" >
                        <Col span={20} style={{ textAlign: "start" }}>
                            <Space direction='vertical'>
                                <Typography level={5} style={{ fontWeight: 400, fontSize: 18, color: "var(--color-white)" }}>Response Time</Typography>
                                <Space size={24}  >
                                    <Space direction='vertical'>
                                        <Typography level={4} style={{ fontWeight: 400, fontSize: 24, color: "var(--color-white)", lineHeight: '22px' }}>196 days</Typography>
                                        <Typography level={5} style={{ fontWeight: 400, fontSize: 18, color: "var(--color-white)", lineHeight: '22px' }}>Best</Typography>
                                    </Space>
                                    <Space direction='vertical'>
                                        <Typography level={4} style={{ fontWeight: 400, fontSize: 24, color: "var(--color-white)", lineHeight: '22px' }}>506 days</Typography>
                                        <Typography level={5} style={{ fontWeight: 400, fontSize: 18, color: "var(--color-white)", lineHeight: '22px' }}>Worst</Typography>
                                    </Space>
                                </Space>
                            </Space>
                        </Col>

                    </Widget>
                </Col>
            </Row>
        </div>

    )
}

export default Widgets